import { render, staticRenderFns } from "./SalesStates.vue?vue&type=template&id=2b6efeec&"
import script from "./SalesStates.vue?vue&type=script&lang=js&"
export * from "./SalesStates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports